export const STATIC_PLAN_DATA = {
    'free': {
        tagline: 'Build your first algo strategy',
        list: [
            'Use credits for strategy ideation, code creation and backtesting.',
            'Full platform access, no restrictions.',
            'Access all markets and premium price data.'
        ],
        credit_usage: [
            {text: 'Build & download', highlight: '1 complete strategy'},
            {text: 'Save', highlight: '1 strategy'},
            {text: 'Generate up to', highlight: '1,000 lines of code'},
        ]
    },
    'builder': {
        tagline: 'Strategy validation',
        usage: [
            {label: 'AI strategy automation', value: 'Standard'},
            {label: 'Cloud backtests', value: 'Unlimited'},
            {label: 'Cloud Optimiser', value: 'Unlimited'},
            {label: 'Execute Trades to MT5', value: 'Included'},
        ],
        list: [
            'Unlimited backtests and optimisation runs from day one',
            'Prove your strategy on real ticks before it risks real money',
            'Upgrade only when you need more AI; everything moves with you'
        ],
        credit_usage: [
            {text: 'Build, optimise & download', highlight: '5 trading strategies'},
            {text: 'Save', highlight: '20 strategies'},
            {text: 'Generate', highlight: '5,000 lines of code'},
        ]
    },
    'pro': {
        tagline: 'Optimise strategy',
        popular: true,
        usage: [
            {label: 'AI strategy automation', value: '6x Core'},
            {label: 'Cloud backtests', value: 'Unlimited'},
            {label: 'Cloud Optimiser', value: 'Unlimited'},
            {label: 'Execute Trades to MT5', value: 'Included'},
        ],
        list: [
            'Six times the AI of Core to build and refine in parallel',
            'More ideas drafted, coded and validated every month',
            'Iterate deeply without rationing your prompts'
        ],
        credit_usage: [
            {text: 'Build, optimise & download', highlight: '15 trading strategies'},
            {text: 'Save', highlight: '50 strategies'},
            {text: 'Generate', highlight: '15,000 lines of code'},
        ]
    },
    'quant': {
        tagline: 'Maintaining edge',
        usage: [
            {label: 'AI strategy automation', value: '15x Core'},
            {label: 'Cloud backtests', value: 'Unlimited'},
            {label: 'Cloud Optimiser', value: 'Unlimited'},
            {label: 'Execute Trades to MT5', value: 'Included'},
        ],
        list: [
            'Run research-grade workloads with 15x the AI of Core',
            'Keep a whole pipeline of strategies tested and current',
            'Scale from one strategy to a book without changing tools'
        ],
        credit_usage: [
            {text: 'Build, optimise & download', highlight: 'unlimited trading strategies'},
            {text: 'Save', highlight: 'Unlimited strategies'},
            {text: 'Generate', highlight: 'Unlimited lines of code'},
        ]
    },
    'sponsor-sm': {
        tagline: 'For active traders refining and deploying strategies',
        list: [
            'Designed for users building and testing weekly',
            'Supports frequent prompt iterations and deeper backtesting',
            'Ideal for progressing from idea to live deployment'
        ],
        credit_usage: [
            {text: 'Build, optimise & download', highlight: '5 trading strategies'},
            {text: 'Save', highlight: '20 strategies'},
            {text: 'Generate', highlight: '5,000 lines of code'},
        ]
    }
};
